<script lang="ts">
	//Design system components
	import {
		Button,
		Modal,
		Wizard,
		WizardContainer,
		WizardContent,
		WizardItem,
	} from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { blur } from 'svelte/transition';
	//Helpers
	import { resetWizardItems, updateWizardStepOnPrevNext } from '../Lists/list-helpers';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	//This component it for temporary usage, need to remove store from rest of the schedules
	export let showModal,
		title,
		callback,
		disabled = false;
	export let editableObject = {};
	export let wizardContentClasses = '';

	export let wizardItems = [...Array(5).keys()].map((_, i) => {
		const item = {
			title: `Step ${i + 1}`,
			active: i === 0 ? true : false,
			disabled: false,
			showMoreDots: false,
			stepNumber: i + 1,
			tooltipTitle: `Step ${i + 1}`,
			activeIndex: i,
		};

		if ([...Array(20).keys()].length - 1 === i) {
			return {
				...item,
				title: 'More',
				showMoreDots: true,
				tooltipTitle: 'More',
			};
		}

		return item;
	});

	let activeStep = wizardItems[0];
	const dispatch = createEventDispatcher();

	const previousButton = $format('button_back');
	let data;

	$: isLastStepWizard = activeStep.activeIndex === Object.keys(wizardItems).length - 1;
	$: isFirstStep = activeStep.activeIndex === 0;
	$: nextButton = isLastStepWizard ? $format('button_save') : $format('button_next');

	const onClickWizardItem = (e, index: number) => {
		wizardItems = wizardItems.map((item, i) => {
			if (i === index) {
				activeStep = {
					...item,
					activeIndex: i,
				};

				return {
					...item,
					active: true,
				};
			}

			return {
				...item,
				active: false,
			};
		});
	};

	let showCondition = false;

	const onCloseEditModal = () => {
		showModal = false;

		wizardItems = resetWizardItems(wizardItems);
		activeStep = wizardItems[0];
	};

	const onFinishCardEdit = async () => {
		dispatch('updateStore', data);
		callback();
		onCloseEditModal();
	};

	const onClickPrevNextButton = (type: 'prev' | 'next') => {
		if (type === 'next') {
			dispatch('updateStore', data);
		}
		const result = updateWizardStepOnPrevNext(type, wizardItems, activeStep);
		wizardItems = result.wizardItems;
		activeStep = { ...result.activeWizardStep };
	};

	const updateData = (e) => {
		data = { ...data, ...e.detail };
	};
</script>

<Modal
	on:close={() => {
		showModal = false;
		showCondition = false;
		onCloseEditModal();
		dispatch('close');
	}}
	{showModal}
	{title}
	hideSlotFooter={showCondition}
	removeScrollPadding
>
	<!-- <svelte:fragment slot="toolbar"> -->
	<Wizard slot="toolbar">
		{#each wizardItems as item, i (i)}
			<WizardItem
				on:click={(e) => {
					onClickWizardItem(e, i);
				}}
				active={item.active}
				title={item.title}
				disabled={item.disabled}
				showMoreDots={item.showMoreDots}
				indicatorColor={$showNewLayout ? 'color-2' : undefined}
			/>
		{/each}
	</Wizard>

	<div class:flex-overflow-hidden={showCondition} slot="content">
		<WizardContainer activeStepIndex={activeStep.activeIndex} adaptiveHeight>
			{#each wizardItems as item, i (i)}
				<WizardContent active={activeStep.activeIndex === i} class={wizardContentClasses}>
					{#if activeStep.activeIndex === i}
						<div class="animate" transition:blur|global>
							<svelte:component
								this={item.component}
								bind:editableObject
								on:update={updateData}
							/>
						</div>
					{/if}
				</WizardContent>
			{/each}
		</WizardContainer>
	</div>

	<div slot="footer" class="d-flex justify-content-end">
		{#if !isFirstStep}
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				icon="fas fa-chevron-left"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => {
					// if (isFirstStep) {
					// 	showModal = false;
					// } else {
					// 	onClickPrevNextButton('prev');
					// }
					onClickPrevNextButton('prev');
				}}
			>
				{previousButton}
			</Button>
		{/if}
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			icon={isLastStepWizard ? 'fas fa-save' : ''}
			rightIcon={isLastStepWizard ? '' : 'fas fa-chevron-right'}
			responsiveSize={{
				sm: 'm',
			}}
			disabled={disabled && isLastStepWizard}
			on:click={() => {
				if (isLastStepWizard) {
					onFinishCardEdit();
				} else {
					onClickPrevNextButton('next');
				}
			}}>{nextButton}</Button
		>
	</div>
</Modal>
